import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  #app {
    min-height: 100%;
    min-width: 100%;
  }

  .x-hellosign-embedded--in-modal {
    z-index: 999;
  }

  /* Ripple's BaseIcon sets no flex-shrink, so an icon sized by its own class
     shrinks beside a label that wraps. MUI's SvgIcon, which these icons
     replace, never shrank. */
  svg[data-slot='icon'] {
    flex-shrink: 0;
  }

  .cameratag_room {
    height: 600px;
  }

  #request-revision-tooltip {
    z-index: 0;
  }

  body #x-gist-floating-bottom-right,
  body #x-gist-floating-bottom {
    z-index: 80;
  }
`;

export default GlobalStyle;
